/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { classnames } from "../../utils/text";
import Button from "../Button";
import Profile from "../Profile";
import Line from "../Line";
import Icon from "../Icon";
import DeleteIcon from "../../assets/images/icon/x-icon.svg";
// task form
import { searchEmployee } from "../../utils/employee";

// redux
import { cloneDeep, each, get, isEmpty, orderBy, remove } from "lodash";

import { shallowEqual, useSelector } from "react-redux";
import TaskEmployeeItem from "./TaskEmployeeItem";

import { sortBy } from "lodash";

const TaskApprovals = (props) => {
  const {
    mode,
    taskData,
    approverEmployees,
    referenceEmployees,
    setApproverEmployees,
    setRefererEmployees,
  } = props;

  const [approverEmployeesSort, setApproverEmployeesSort] = useState([]);
  const [referenceEmployeesSort, setReferenceEmployeesSort] = useState([]);

  const [requestEmployee, setRequestEmployee] = useState(null);
  const {
    employees,
    ceos,
  } = useSelector(
    (store) => ({
      employees: store.Data.employees,
      ceos: store.Data.ceos,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (!isEmpty(employees)) {
      const _employees = orderBy(employees, 'idx');
      // 결제 인원이 없는 경우 대표 or 회사의 제일 idx 빠른사람 주입
      if (isEmpty(approverEmployees)) {
        setApproverEmployees(ceos || [_employees[0]]);
      }
    }
  }, [employees]);

  useEffect(() => {
    setApproverEmployeesSort(sortBy(approverEmployees, 'code').reverse());
    setReferenceEmployeesSort(sortBy(referenceEmployees, 'code').reverse());
  }, [approverEmployees, referenceEmployees]);

  const _setApproverEmployees = (_employees) => {
    const approver = [];
    const reference = [];
    each(_employees, (employee) => {
      // TODO 외부 직원일경우 데이터를 가져올수 없음.
      const approverEmployeeIdx = get(employee, 'approverEmployee.idx');
      const handOverEmployeeIdx = get(employee, 'approvalHandover.targetEmpIdx');
      const approverEmployee = cloneDeep(employees.find(_e => _e.idx === approverEmployeeIdx));

      const handOverStatus = get(employee, 'approvalHandover.approvalTarget.status', 'canceled');
      let handOverEmployee = null;
      if (handOverEmployeeIdx && handOverStatus === "approved") {
        handOverEmployee = cloneDeep(employees.find(_e => _e.idx === handOverEmployeeIdx));
        handOverEmployee.approverOrigin = cloneDeep(approverEmployee);
      }
      let resultApproverEmployee = cloneDeep(handOverEmployee || approverEmployee);
      resultApproverEmployee.data = employee;
      if (employee.type === "approver") {
        approver.push(resultApproverEmployee);
      }
      if (employee.type === "reference") {
        reference.push(resultApproverEmployee);
      }
    });
    setApproverEmployees(approver);
    setRefererEmployees(reference);
  };

  useEffect(() => {
    if (!isEmpty(taskData)) {
      _setApproverEmployees(taskData.approvalTarget.approvals);
      const requestEmployeeIdx = get(taskData, 'approvalTarget.requesterEmpIdx');
      setRequestEmployee(employees.find(_e => _e.idx === requestEmployeeIdx));
    }
  }, [taskData]);

  const openApproverEmployees = () => {
    searchEmployee((employees) => {
      setApproverEmployees(employees);
    }, approverEmployees, { isExceptLeave: true });
  };

  const openRefererEmployees = () => {
    searchEmployee((employees) => {
      setRefererEmployees(employees);
    }, referenceEmployees);
  };

  const deleteApproverEmployee = (employee) => {
    remove(approverEmployees, e => e.idx === employee.idx);
    setApproverEmployees([...approverEmployees]);
  };
  const deleteRefererEmployee = (employee) => {
    remove(referenceEmployees, e => e.idx === employee.idx);
    setRefererEmployees([...referenceEmployees]);
  };

  return <>
    <div className="task-approval-area">
      <h3>담당자</h3>
      <div className={classnames(
        "employee-list",
        `employee-list-${mode}`,
        `employee-list-${approverEmployees.length}`
      )}>
        {isEmpty(approverEmployees) ?
          <div className="empty-employee">
            담당자를 추가해주세요.
          </div>
          : <>
            {
              requestEmployee &&
              <TaskEmployeeItem
                isRequester={true}
                taskData={taskData}
                mode={mode}
                employee={requestEmployee}
              ></TaskEmployeeItem>
            }
            {approverEmployeesSort.map((employee, idx) => (
              !ceos.find(_e => _e.idx === employee.idx) &&
              <TaskEmployeeItem
                key={idx}
                taskData={taskData}
                mode={mode}
                employee={employee}
                deleteEmployee={deleteApproverEmployee}
              ></TaskEmployeeItem>
            ))
            }
            {approverEmployeesSort.map((employee, idx) => (
              ceos.find(_e => _e.idx === employee.idx) &&
              <TaskEmployeeItem
                key={idx}
                taskData={taskData}
                mode={mode}
                employee={employee}
                deleteEmployee={deleteApproverEmployee}
              ></TaskEmployeeItem>
            ))
            }
          </>
        }
      </div>
      {
        mode === 'create' &&
        <div className="button-wrap">
          <Button
            onClick={openApproverEmployees}
            className="add w-full"
            color="purple"
          >담당자 추가</Button>
        </div>
      }
      <Line></Line>
      <h3>참조</h3>
      <div className="employee-list">
        {isEmpty(referenceEmployees) ?
          <div className="empty-employee">
            참조 안함
          </div>
          : <>
            {
              referenceEmployeesSort.map((employee, idx) => (
                !ceos.find(_e => _e.idx === employee.idx) &&
                <div className="employee-item" key={idx}>
                  <Profile data={employee}></Profile>
                  {
                    mode === 'create' &&
                    <Button
                      className="employee-delete-button"
                      color="text"
                      onClick={() => deleteRefererEmployee(employee)}
                    >
                      <Icon src={DeleteIcon}></Icon>
                    </Button>
                  }
                </div>
              ))
            }
            {
              referenceEmployeesSort.map((employee, idx) => (
                ceos.find(_e => _e.idx === employee.idx) &&
                <div className="employee-item" key={idx}>
                  <Profile data={employee}></Profile>
                  {
                    mode === 'create' &&
                    <Button
                      className="employee-delete-button"
                      color="text"
                      onClick={() => deleteRefererEmployee(employee)}
                    >
                      <Icon src={DeleteIcon}></Icon>
                    </Button>
                  }
                </div>
              ))
            }
          </>}
      </div>
      {
        mode === 'create' &&
        <div className="button-wrap">
          <Button
            onClick={openRefererEmployees}
            className="add w-full"
            color="purple"
          >참조자 추가</Button>
        </div>
      }
    </div>
  </>;
};


export default TaskApprovals;
